import { PagesModule } from 'pages/pages.module';
import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { CoachClaimPage } from 'pages/coach-claim/coach-claim';

@NgModule({
    declarations: [CoachClaimPage],
    imports: [PagesModule, ComponentsModule]
})
export class CoachClaimPageModule {}
